import * as colors from "../constants/colors";
import * as languages from "../constants/languages";
import { css, StyleSheet } from "aphrodite";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { format } from "date-fns";
import * as es from "date-fns/locale/es";
import * as en from "date-fns/locale/en";
import querystring from "querystring";

const dateFormat = "ddd., MMM. D";
const timeFormat = "h:mmA";

const styles = StyleSheet.create({
	mainButton: {
		border: `3px solid ${colors.darkTeal2}`,
		borderRadius: 16,
		backgroundColor: colors.lightTeal,
		color: colors.darkGreen,
		width: 168,
		height: 50,
		fontWeight: "bold",
		fontFamily: "priori-sans",
		fontSize: 18,
		lineHeight: 0.94,
	},
	buttonCellStyle: {
		paddingLeft: 0,
		textAlign: "center",
	},
	cellStyle: {
		width: "33%",
		fontSize: 24,
		textAlign: "left",
		paddingTop: 10,
		paddingLeft: 16,
		paddingBottom: 10,
		borderBottom: `1px dashed ${colors.gray2}`,
		backgroundColor: colors.lightTeal3,
	},
	centerCellStyle: {
		borderLeft: `1px solid ${colors.gray2}`,
		borderRight: `1px solid ${colors.gray2}`,
		fontWeight: "normal",
	},
	fontNormal: {
		fontWeight: "normal",
	},
});

export default class LiveSession extends PureComponent {
	static propTypes = {
		buttonName: PropTypes.string.isRequired,
		registrationClosed: PropTypes.string.isRequired,
		classId: PropTypes.string,
		email: PropTypes.string,
		language: PropTypes.string,
		session: PropTypes.shape({
			id: PropTypes.string.isRequired,
			startTime: PropTypes.string.isRequired,
			endTime: PropTypes.string.isRequired,
			registrationURL: PropTypes.string,
			completionURL: PropTypes.string,
			registrationFull: PropTypes.bool,
			livestormID: PropTypes.string,
		}).isRequired,
		onSessionSelect: PropTypes.func.isRequired,
	};

	_startClass = () => {
		const qs = querystring.stringify({
			email: this.props.email ? this.props.email : "",
			language: this.props.language ? this.props.language : "",
		});
		if (!this.props.session.livestormID) {
			window.location.assign(`${this.props.session.registrationURL}?${qs}`);
		} else {
			this.props.onSessionSelect(this.props.session);
		}
	};

	render() {
		const startTime = new Date(this.props.session.startTime);
		const endTime = new Date(this.props.session.endTime);
		const locale = { locale: this.props.language === languages.es ? es : en };
		return (
			<tr key={this.props.session.id}>
				<td className={css(styles.cellStyle)}>{format(startTime, dateFormat, locale)}</td>
				<td className={css([styles.cellStyle, styles.centerCellStyle])}>
					{`${format(startTime, timeFormat, locale)} - ${format(
						endTime,
						timeFormat,
						locale,
					)}`}
				</td>
				<td className={css([styles.cellStyle, styles.buttonCellStyle])}>
					{this.props.session.registrationFull ? (
						<div className={css(styles.fontNormal)}>
							{this.props.registrationClosed}
						</div>
					) : (
						<button
							onClick={this._startClass}
							className={css(styles.mainButton)}
							disabled={this.props.session.registrationFull}
						>
							{this.props.buttonName}
						</button>
					)}
				</td>
			</tr>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/LiveSession.js